// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
export const JUPYTER_WIDGETS_VERSION = '1.2.0';
export const PROTOCOL_VERSION = '2.1.0';
